import mergeSystemFields from 'coact/utils/schema/mergeSystemFields'
import mergeClientRequiredChanges from 'coact/utils/schema/mergeClientRequiredChanges'

function create(schema) {
  return mergeSystemFields(schema)
}

function adaptClient(schema) {
  return mergeClientRequiredChanges(schema)
}

export default {
  create,
  adaptClient,
}
